module.exports = __webpack_public_path__ + "static/trying-to-loot-0cc048e1c63df241722b20f7e6ed97ec.webp";